<mat-menu #menu="matMenu">
  <button [attr.guide]="sanitizedUrl + '-follow-up-btn'" *ngIf="crmType!=2" mat-menu-item>Follow Up
  </button>
  <button [attr.guide]="sanitizedUrl + '-phone-call-btn'" mat-menu-item>Phone Call</button>
</mat-menu>


<div class="root" *ngIf="kanbanviewType == 1 ">
  <div class="board">
    <div class="board-wrapper">
      <div class="board-columns">

        <div cdkDropList cdkDropListOrientation="horizontal" class="board-columns"
          (cdkDropListDropped)="dropGrid($event)">
          <div cdkDragLockAxis="x" class="board-column" *ngFor="let column of DealStatusList; index as i" cdkDrag>
            <div
              [ngStyle]="{'background-color': column.statusColor ? column.statusColor : 'var(--leftbackground-color)', 'color': column.statusColor ? 'white' : 'var(--leftprimary-color)'}"
              class="column-title" cdkDragHandle>
              {{ column.statusName }}
              <span class="total-amount">{{ column.totalDeals | currencyConvert}}</span>

            </div>

            <div class="tasks-container" id="{{column.statusId}}" [cdkDropListConnectedTo]="connectedList" cdkDropList
              [cdkDropListData]="column.tasks" (cdkDropListDropped)="drop($event)"
              (scroll)="onColumnScroll($event, column, i)">
              <div class="task" [attr.guide]="sanitizedUrl + '-deal-card-' + item.entityId"
                *ngFor="let item of column.tasks" (mouseenter)="item.hovered = true" (mouseleave)="item.hovered = false"
                cdkDrag>

                <div class="task-body">
                  <div [attr.guide]="sanitizedUrl + '-edit-deal-btn-' + item.entityId"
                    (click)="editProduct(item.entityId,item.attributeSetId)" class="deal-name"
                    [class.hover-blue]="item.hovered">{{ item.dealsName | titlecase }}</div>

                  <div [attr.guide]="sanitizedUrl + '-go-to-lead-btn-' + item.leadId" *ngIf="item.leadId>0"
                    class="leadName" (click)="goToLead(item)">{{ item.leadName | titlecase }}
                  </div>
                  <div [attr.guide]="sanitizedUrl + '-go-to-company-btn-' + item.companyId" *ngIf="item.companyId>0"
                    class="leadName" (click)="goToCompany(item)">{{ item.company | titlecase
                    }}</div>
                  <div class="deal-stage">{{ item.stage | titlecase }}</div>
                  <div class="deal-owner">{{ item.dealsOwner | titlecase }}</div>

                  <div class="deal-value">{{ item.amount | currencyConvert }}</div>
                </div>

                <div class="task-footer">
                  <span class="date-text" *ngIf="item.closingDate">
                    {{ item.closingDate | date:'dd-MM-yyyy' }}
                  </span>
                  <span class="icon-container">
                    <mat-icon [attr.guide]="sanitizedUrl + '-edit-deal-icon-' + item.entityId"
                      matTooltip="Edit Deals as your Needs" matTooltipPosition="above"
                      (click)="editProduct(item.entityId,item.attributeSetId)">calendar_today</mat-icon>
                  </span>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<div class="root" *ngIf="kanbanviewType == 2 ">
  <div class="board">
    <div class="board-wrapper">
      <div class="board-columns">

        <div cdkDropList cdkDropListOrientation="horizontal" class="board-columns"
          (cdkDropListDropped)="dropGrid($event)">
          <div cdkDragLockAxis="x" class="board-column" *ngFor="let column of DealStatusList; index as i" cdkDrag>
            <div [ngStyle]="{
      'background-color': column.backgroundColorAdjusted,
      'border-top': column.borderColorAdjusted,
      'color': defaultTextcolor
    }" class="column-title" cdkDragHandle>
              <div class="status-header" style="color: rgb(15, 15, 15);">
                {{ column.statusName }}
                <!-- <span>{{ column.docCount }} </span> -->
                <div class="contact-count" style="color: rgb(123, 118, 118);">Deals {{ column.amount | currencyConvert
                  }}</div>
              </div>
            </div>

            <!-- <div fxLayout="row" fxLayoutAlign="center center" class="add-contact-container" (click)="addContact()">
              <button [attr.guide]="sanitizedUrl + '-add-deals-btn'" mat-button class="add-button" disableRipple>
                <mat-icon class="add-icon">add</mat-icon>
                <span class="add-text">Add Deals</span>
              </button>
            </div> -->

            <div class="tasks-container" id="{{column.statusId}}" [cdkDropListConnectedTo]="connectedList" cdkDropList
              [cdkDropListData]="column.tasks" (cdkDropListDropped)="drop($event)"
              (scroll)="onColumnScroll($event, column, i)">
              <div class="task" [attr.guide]="sanitizedUrl + '-deal-card-v2-' + item.entityId"
                *ngFor="let item of column.tasks" (mouseenter)="item.hovered = true" (mouseleave)="item.hovered = false"
                cdkDrag>

                <div class="task-body">
                  <div [attr.guide]="sanitizedUrl + '-edit-deal-btn-v2-' + item.entityId"
                    (click)="editProduct(item.entityId,item.attributeSetId)" class="deal-name"
                    [class.hover-blue]="item.hovered">{{ item.dealsName | titlecase }}</div>
                  <div [attr.guide]="sanitizedUrl + '-go-to-company-btn-v2-' + item.companyId" *ngIf="item.companyId>0"
                    class="leadName" (click)="goToCompany(item)">{{ item.company | titlecase
                    }}</div>
                  <div [attr.guide]="sanitizedUrl + '-go-to-lead-btn-v2-' + item.leadId" *ngIf="item.leadId>0"
                    class="leadName" (click)="goToLead(item)">{{ item.leadName | titlecase }}
                  </div>

                  <div class="deal-stage">{{ item.stage | titlecase }}</div>
                  <div class="deal-owner">{{ item.dealsOwner | titlecase }}</div>

                  <div class="deal-value">{{ item.amount | currencyConvert }}</div>
                </div>

                <div class="task-footer">
                  <span class="date-text" *ngIf="item.closingDate">
                    {{ item.closingDate | date:'dd-MM-yyyy' }}
                  </span>
                  <span class="icon-container">
                    <mat-icon [attr.guide]="sanitizedUrl + '-edit-deal-icon-v2-' + item.entityId"
                      matTooltip="Edit Deals as your Needs" matTooltipPosition="above"
                      (click)="editProduct(item.entityId,item.attributeSetId)">edit</mat-icon>
                  </span>
                </div>
              </div>
              <div *ngIf="column.loading" class="loading-indicator">
                Loading more deals...
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</div>


<div class="root" *ngIf="kanbanviewType == 3">
  <div class="board">
    <div class="board-wrapper">
      <div class="board-columns">

        <div cdkDropList cdkDropListOrientation="horizontal" class="board-columns"
          (cdkDropListDropped)="dropGrid($event)">
          <div class="board-column" *ngFor="let column of DealStatusList; index as i" cdkDrag cdkDragLockAxis="x">

            <!-- COLUMN HEADER -->
            <div class="column-title1" cdkDragHandle [ngStyle]="{
      'border-bottom': column.borderColorAdjusted,
       'background-color': column.backgroundColorAdjusted,
       'color': defaultTextcolor
    }">
              <div class="status-header" style="width: 100%;" fxLayout="row" fxLayoutAlign="space-between start"
                fxLayoutGap="10px">
                <div class="status-name" fxFlex="70" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start start">
                  <!-- {{ column.statusName }}
                  <span class="count">{{ column.docCount }}</span> -->
                  <div fxFlex="60" style="word-break: break-all;">
                    {{ column.statusName }}
                  </div>
                  <div fxFlex="15" class="status-count">
                    {{ column.docCount }}
                  </div>
                </div>

                <div fxFlex class="contact-count">
                  <!-- Deals {{ column.amount | currencyConvert }} -->
                  {{ column.amount | currencyConvert }}
                </div>
              </div>
            </div>

            <!-- TASKS -->
            <div class="tasks-container" id="{{ column.statusId }}" cdkDropList [cdkDropListConnectedTo]="connectedList"
              [cdkDropListData]="column.tasks" (cdkDropListDropped)="drop($event)"
              (scroll)="onColumnScroll($event, column, i)">
              <div class="deal-card" [attr.guide]="sanitizedUrl + '-deal-card-v3-' + item.entityId" [ngStyle]="{
                    '--deal-accent-color': column.accentColor
                  }" *ngFor="let item of column.tasks" cdkDrag>

                <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between" style="padding: 5px;">
                  <div fxLayout="column">
                    <div class="deal-header">
                      <div [attr.guide]="sanitizedUrl + '-edit-deal-btn-v3-' + item.entityId" class="deal-title"
                        (click)="editProduct(item.entityId, item.attributeSetId)">
                        {{ item.dealsName }}
                      </div>

                      <!-- <div class="owner-avatar">
                    {{ item.dealsOwner| uppercase }}
                  </div> -->

                    </div>

                    <!-- COMPANY / LEAD -->
                    <div [attr.guide]="sanitizedUrl + '-go-to-company-btn-v3-' + item.companyId" class="deal-company"
                      *ngIf="item.companyId > 0">
                      <mat-icon>domain</mat-icon>
                      <span (click)="goToCompany(item)">
                        {{ item.company | titlecase }}
                      </span>
                    </div>

                    <div [attr.guide]="sanitizedUrl + '-go-to-lead-btn-v3-' + item.leadId" class="deal-company"
                      *ngIf="item.leadId > 0">
                      <mat-icon>person</mat-icon>
                      <span (click)="goToLead(item)">
                        {{ item.leadName | titlecase }}
                      </span>
                    </div>

                    <!-- AMOUNT -->
                    <div class="deal-amount">
                      {{ item.amount | currencyConvert }}
                    </div>
                  </div>
                  <div fxLayoutAlign="end end" *ngIf="item.dealsOwner">
                    <div class="owner-avatar">
                      {{
                      (item.dealsOwner?.split(' ')[0]?.charAt(0) || '') +
                      (item.dealsOwner?.split(' ')[1]?.charAt(0) || '')
                      | uppercase
                      }}
                    </div>
                  </div>

                </div>


                <!-- <div class="deal-divider"></div> -->


                <div class="deal-footer">
                  <div [attr.guide]="sanitizedUrl + '-edit-deal-footer-v3-' + item.entityId" class="dates"
                    fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="5px"
                    (click)="editProduct(item.entityId, item.attributeSetId)">
                    <mat-icon>calendar_today</mat-icon>
                    <div>
                      {{ item.closingDate | date: 'dd-MM-yyyy' }}
                    </div>
                  </div>

                  <!-- <mat-icon matTooltip="Edit Deal" (click)="editProduct(item.entityId, item.attributeSetId)">
                      edit
                    </mat-icon> -->
                </div>
              </div>

              <!-- LOADING -->
              <div *ngIf="column.loading" class="loading-indicator">
                Loading more deals...
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>